<template>
  <div class="company_services">

    <TextTable
      :all_data = "all_data"
    />

  </div>
</template>

<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'CompanyServices',
  components: {
    TextTable
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      load: true,
      all_data: {}
    }
  },

  created () {
    this.get_services()
  },

  methods: {
    get_services(){
      this.$http.v1.getCompanyServices((response) => {
        this.all_data = response.data
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .company_services{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
